(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.DialogController = (function(superClass) {
    extend(DialogController, superClass);

    function DialogController(scope, transitions, modalInstance) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.save = bind(this.save, this);
      this.cancel = bind(this.cancel, this);
      this.closeWithAlert = bind(this.closeWithAlert, this);
      DialogController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.save = this.save;
      this.scope.cancel = this.cancel;
      this.scope.closeWithAlert = this.closeWithAlert;
    }

    DialogController.prototype.closeWithAlert = function(json_status, data, timeout) {
      var messages;
      if (data == null) {
        data = null;
      }
      if (timeout == null) {
        timeout = 1000;
      }
      if (json_status == null) {
        return;
      }
      if (json_status.type === 'error' && (data != null ? data.messages : void 0) instanceof Array) {
        messages = data.messages;
      }
      this.scope.setAlert(json_status, messages, timeout);
      if (json_status.type !== 'error') {
        return setTimeout((function(_this) {
          return function() {
            return _this.modalInstance.close(data);
          };
        })(this), timeout);
      }
    };

    DialogController.prototype.cancel = function() {
      return this.modalInstance.dismiss('cancel');
    };

    DialogController.prototype.save = function(data) {
      if (data == null) {
        data = null;
      }
      return this.modalInstance.close(data);
    };

    return DialogController;

  })(Controller);

}).call(this);
